import * as React from "react";
import { useNavigate, Link } from "react-router-dom";
import { Disclosure, Menu, Transition } from "@headlessui/react";
import { BellIcon, MenuIcon, XIcon } from "@heroicons/react/outline";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../redux/Actions/Actions";

const navigation = [
  { name: "Dashboard", href: "/", current: false },
  { name: "AddressBook", href: "/addressbook", current: false },
  { name: "Enquiry", href: "/enquiry", current: false },
  { name: "Service", href: "/serviceticket", current: false },
  { name: "Tasks", href: "/servicetask", current: false },
  { name: "Meetings", href: "/meetings", current: false },
  { name: "Properties", href: "/property", current: false },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const isCurrentPage = (itemHref, currentUrl) => {
  return itemHref.toLowerCase() === "/" + currentUrl.toLowerCase();
};

export default function NavBar({ currentpage }) {
  const state = useSelector((state) => state.UserReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userAvatar = state.user.avatar;
  const logoutUser = async () => {
    console.log("Logout");
    dispatch(logout(state));
    localStorage.removeItem("63cea11a56a16759beca56461fe85621");
    localStorage.clear();
    navigate("/login");
  };

  const currentpagestate = window.location.pathname.split("/")[1];

  return (
    <>
      <div className='min-h-full duration-300'>
        <Disclosure as='nav' className='bg-gray-50'>
          {({ open }) => (
            <>
              <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
                <div className='relative flex items-center justify-between h-16'>
                  <div className='absolute inset-y-0 left-0 flex items-center sm:hidden'>
                    {/* Mobile menu button*/}
                    <Disclosure.Button className='inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white'>
                      <span className='sr-only'>Open main menu</span>
                      {open ? (
                        <XIcon className='block h-6 w-6' aria-hidden='true' />
                      ) : (
                        <MenuIcon
                          className='block h-6 w-6'
                          aria-hidden='true'
                        />
                      )}
                    </Disclosure.Button>
                  </div>
                  <div className='flex-1 flex items-center justify-center sm:items-stretch sm:justify-start'>
                    <div className='flex-shrink-0 flex items-center'>
                      <img
                        className='block sm:hidden h-8 w-auto'
                        src='/assets/images/logo_cropped.png'
                        alt='L&amp;L'
                      />
                    </div>
                    <div className='hidden sm:block sm:ml-6'>
                      <div className='flex space-x-4'>
                        {navigation.map((item) => (
                          <Link
                            key={item?.name}
                            to={item?.href}
                            className={classNames(
                              isCurrentPage(item?.href, currentpagestate)
                                ? "bg-yellow text-white"
                                : "text-gray-200 hover:bg-gray-700 hover:text-white",
                              "px-3 py-2 rounded-sm text-xs font-medium focus:ring-yellow-2",
                            )}
                            aria-current={item?.current ? "page" : undefined}>
                            {item?.name}
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className='absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0'>
                    {/* Profile dropdown */}
                    <Menu as='div' className='ml-3 relative'>
                      <div>
                        <Menu.Button
                          className={`bg-yellow flex text-sm rounded-full ${
                            currentpagestate === "user"
                              ? "outline-none ring-2 ring-offset-2 ring-offset-yellow ring-yellow"
                              : "focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-yellow focus:ring-yellow"
                          }`}>
                          <span className='sr-only'>Open user menu</span>
                          <img
                            className='h-8 w-8 rounded-full'
                            src={userAvatar}
                            alt=''
                            referrerPolicy='no-referrer'
                          />
                        </Menu.Button>
                      </div>
                      <Transition
                        as={React.Fragment}
                        enter='transition ease-out duration-100'
                        enterFrom='transform opacity-0 scale-95'
                        enterTo='transform opacity-100 scale-100'
                        leave='transition ease-in duration-75'
                        leaveFrom='transform opacity-100 scale-100'
                        leaveTo='transform opacity-0 scale-95'>
                        <Menu.Items className='origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-yellow ring-opacity-5 focus:outline-none'>
                          <Menu.Item>
                            {({ active }) => (
                              <span className='bg-gray-50 block px-4 py-2 text-sm font-semibold text-gray-700'>
                                {state.user.firstName +
                                  " (" +
                                  state.user.department?.name +
                                  ")"}
                              </span>
                            )}
                          </Menu.Item>
                          <Menu.Item>
                            {({ active }) => (
                              <Link
                                to='/user/my-profile'
                                className={classNames(
                                  active ? "bg-gray-100" : "",
                                  "block px-4 py-2 text-sm text-gray-700",
                                )}>
                                Your Profile
                              </Link>
                            )}
                          </Menu.Item>
                          {(state.user.aclGroup === "manager" ||
                            state.user.aclGroup === "lead" ||
                            state.user.aclGroup === "admin" ||
                            state.user.aclGroup === "super-admin") && (
                            <Menu.Item>
                              {({ active }) => (
                                <Link
                                  to='/admin/form-input-settings'
                                  className={classNames(
                                    active ? "bg-gray-100" : "",
                                    "block px-4 py-2 text-sm text-gray-700",
                                  )}>
                                  Settings
                                </Link>
                              )}
                            </Menu.Item>
                          )}
                          {(state.user.aclGroup === "manager" ||
                            state.user.aclGroup === "lead" ||
                            state.user.aclGroup === "admin" ||
                            state.user.aclGroup === "super-admin") && (
                            <Menu.Item>
                              {({ active }) => (
                                <Link
                                  to='/user/manage-user-accounts'
                                  className={classNames(
                                    active ? "bg-gray-100" : "",
                                    "block px-4 py-2 text-sm text-gray-700",
                                  )}>
                                  Manage Users
                                </Link>
                              )}
                            </Menu.Item>
                          )}
                          <Menu.Item
                            onClick={(e) => {
                              logoutUser();
                            }}>
                            {({ active }) => (
                              <Link
                                to='#'
                                className={classNames(
                                  active ? "bg-gray-100" : "",
                                  "block px-4 py-2 text-sm text-gray-700",
                                )}>
                                Sign out
                              </Link>
                            )}
                          </Menu.Item>
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  </div>
                </div>
              </div>

              <Disclosure.Panel className='sm:hidden'>
                <div className='px-2 pt-2 pb-3 space-y-1'>
                  {navigation.map((item) => (
                    <Disclosure.Button
                      key={item?.name}
                      href='#'
                      as='NavLink'
                      onClick={(e) => {
                        navigate(item?.href, { replace: false });
                      }}
                      href={item?.href}
                      className={classNames(
                        isCurrentPage(item?.href, currentpagestate)
                          ? "bg-yellow text-white"
                          : "text-gray-200 hover:bg-gray-700 hover:text-white",
                        "block px-3 py-2 rounded-md text-base font-medium",
                      )}
                      aria-current={item?.current ? "page" : undefined}>
                      {item?.name}
                    </Disclosure.Button>
                  ))}
                </div>
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      </div>
    </>
  );
}
